import React, {useRef,useState} from "react";
import { Table, Tag, List, Grid, Button, Space, InputNumber, Select, Tooltip, Segmented, Collapse } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import styles from "./ScheduleViewer.module.css";
import { useKeycloak } from "@react-keycloak/web";
import { useSelector, useDispatch } from "react-redux";
import { days, shiftColors, getWeekNumber, getDateFromWeekAndDay, getColorFromStatus, dayStatuses, getTextColorForStatus } from "../../core/utils/weekPlanUtils";
import { useEffect } from "react";
import { transformBackendData } from "./viewerDataTransformer";
import dayjs from 'dayjs';
import { LeftOutlined, RightOutlined, HomeOutlined, CalendarOutlined, TableOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';
import MonthlyScheduleTable from "./MonthlyScheduleTable";
import { getUserWeekPlanInOrgByWeekAndYear } from "../../redux/slieces/weekPlanSlice";
import { getUserMonthPlanInOrgByMonthAndYear } from '../../redux/slieces/monthPlanSlice';
import { getOrganizationSettings } from "../../redux/slieces/organizationSettingsSlice";
import { getUsersInOrganisation } from "../../redux/slieces/userSlice";
import { sortWorkers } from "../../utils/workerSorting";
const { useBreakpoint } = Grid;

const getTestData = () => [
    {
      name: "Anna",
      schedule: {
        Monday: [
          { time: "08:00-12:00", type: "early" },
          { time: "13:00-17:00", type: "late" },
        ],
        Tuesday: [],
        Wednesday: [{ time: "14:00-20:00", type: "late" }],
        Thursday: [],
        Friday: [{ time: "06:00-14:00", type: "early" }],
        Saturday: [],
        Sunday: [],
      },
    },
    {
      name: "Jonas",
      schedule: {
        Monday: [],
        Tuesday: [{ time: "09:00-17:00", type: "early" }],
        Wednesday: [],
        Thursday: [{ time: "18:00-00:00", type: "night" }],
        Friday: [],
        Saturday: [
          { time: "08:00-12:00", type: "early" },
          { time: "13:00-15:00", type: "late" },
        ],
        Sunday: [],
      },
    },
  ];
  
 



const ScheduleViewer = ({test=false}) => {
    const screens = useBreakpoint();
    const currentDate = new Date();
    const [data,setData]=useState([]);
    const { keycloak, initialized } = useKeycloak();
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1); // month 1�12
    const [viewMode, setViewMode] = useState("weekly");
    const dispatch = useDispatch();
    const {
        loading: monthLoading,
        error: monthError,
        monthPlanSchedules
    } = useSelector((state) => state.monthPlan.MonthPlanData || {});
   
    const [selectedWeek, setSelectedWeek] = useState(getWeekNumber(currentDate));

    
    const {loading, error, weekPlanSchedules} = useSelector(state => state.weekPlan.WeekPlanData);
    const { settings: organizationSettings } = useSelector((state) => state.organizationSettings);
    const { users } = useSelector((state) => state.userData.users);
    const pdfRef=useRef();
    const { t } = useTranslation();

    const renderShiftCell = (entry) => {

      const { shifts = [], status } = entry || {};


      if (status !== "Work") {
        const bgColor = getColorFromStatus(status);
        const textColor = getTextColorForStatus(status);
        return (
          <Tag
            style={{
              backgroundColor: bgColor,
              color: textColor,
              border: "none",
              fontWeight: 600,
              textShadow: textColor === '#ffffff' ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
              padding: '4px 12px',
              borderRadius: '4px'
            }}
          >
            {t(`statuses.${status?.toLowerCase()}`)}
          </Tag>
        );
      }

      const early = shifts.filter((s) => s.type === "early");
      const late = shifts.filter((s) => s.type === "late");
      const night = shifts.filter((s) => s.type === "night");

      return (
        <div className="shift-cell">
          <div className="shift-row">
            <div className="shift-left">
              {early.map((shift, index) => (
                <Tag key={`e-${index}`} color={shiftColors[shift.type]} className="shift-tag">
                  {shift.time}
                </Tag>
              ))}
            </div>
            <div className="shift-right">
              {late.map((shift, index) => (
                <Tag key={`l-${index}`} color={shiftColors[shift.type]} className="shift-tag">
                  {shift.time}
                </Tag>
              ))}
            </div>
          </div>
          {night.length > 0 && (
            <div className="shift-center">
              {night.map((shift, index) => (
                <Tag key={`n-${index}`} color={shiftColors[shift.type]} className="shift-tag">
                  {shift.time}
                </Tag>
              ))}
            </div>
          )}
        </div>
      );
    };
    const updateMonthPlan=(month,year)=>{
        setSelectedMonth(month);
        setSelectedYear(year);
    }

    // Week navigation handlers
    const handlePrevWeek = () => {
        if (selectedWeek > 1) {
            setSelectedWeek(selectedWeek - 1);
        } else {
            setSelectedWeek(52);
            setSelectedYear(selectedYear - 1);
        }
    };

    const handleNextWeek = () => {
        if (selectedWeek < 52) {
            setSelectedWeek(selectedWeek + 1);
        } else {
            setSelectedWeek(1);
            setSelectedYear(selectedYear + 1);
        }
    };

    const handleCurrentWeek = () => {
        const now = new Date();
        setSelectedWeek(getWeekNumber(now));
        setSelectedYear(now.getFullYear());
    };

    // Get week date range for display
    const getWeekDateRange = () => {
        const startDate = getDateFromWeekAndDay(selectedYear, selectedWeek, 'Monday');
        const endDate = getDateFromWeekAndDay(selectedYear, selectedWeek, 'Sunday');
        return `${dayjs(startDate).format('DD.MM')} - ${dayjs(endDate).format('DD.MM.YYYY')}`;
    };
 
    useEffect(() => {
        if (!initialized) return;

        // Fetch organization settings and users for sorting
        dispatch(getOrganizationSettings());
        dispatch(getUsersInOrganisation());

        if (test) {
            setData(getTestData());
        } else {
            if (viewMode === "weekly") {
                // viewerMode: true to show all employees in the schedule viewer (read-only)
                dispatch(getUserWeekPlanInOrgByWeekAndYear({ week: selectedWeek, year: selectedYear, viewerMode: true }));
            } else if (viewMode === "monthly") {
                dispatch(getUserMonthPlanInOrgByMonthAndYear({ month: selectedMonth, year: selectedYear }));
            }
        }
    }, [dispatch, initialized, test, selectedWeek, selectedYear, selectedMonth, viewMode]);

    useEffect(() => {
        const transformed = transformBackendData(weekPlanSchedules);
        const sorted = sortWorkers(transformed || [], users, organizationSettings);
        setData(sorted);

    }, [weekPlanSchedules, users, organizationSettings]);
    useEffect(() => {
        if (viewMode === "monthly") {
            const sorted = sortWorkers(monthPlanSchedules || [], users, organizationSettings);
            setData(sorted);
        }
    }, [monthPlanSchedules, viewMode, users, organizationSettings]);
    const exportToPDF = (week, year) => {
        const input = pdfRef.current;
        html2canvas(input).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("landscape", "mm", "a4");
          const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
          pdf.save(`weekPlan_${week}_${year}.pdf`);
        });
      }
      const columns = [
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          fixed: "left",
        },
        ...days.map((day) => ({
            title: (
                <div>
                  <div><div>{t(`days.${day.toLowerCase()}`)}</div></div>
                  <div style={{ fontSize: "12px", color: "#888" }}>
                    {dayjs(getDateFromWeekAndDay(selectedYear, selectedWeek, day)).format("DD.MM.YYYY")}
                  </div>
                </div>
              ),
          key: day,
          render: (_, record) => renderShiftCell(record.schedule[day]),
        })),
      ];
    if (!initialized) return <div>{t("loadingAuthentication") }...</div>;
    if (loading) return <div>{t("loadingWeekplan") }...</div>;
    if (error) return <div>{t("errorLoadingweekplan") }: {error}</div>;
    return (
      <div className={styles.scheduleWrapper}>
        {/* Enhanced Header with Modern Controls */}
        <div className={styles.viewerHeader}>
          <h1 className={styles.viewerTitle}>
            {t('scheduleViewer')}
          </h1>

          <div className={styles.viewerControls}>
            {/* View Mode Toggle - Using Segmented for better UX */}
            <Segmented
              className={styles.viewModeSegmented}
              options={[
                { label: <span><CalendarOutlined /> {t('weekly')}</span>, value: 'weekly' },
                { label: <span><TableOutlined /> {t('monthly')}</span>, value: 'monthly' }
              ]}
              value={viewMode}
              onChange={setViewMode}
            />

            {/* Weekly Navigation Controls - Only shown in weekly mode */}
            {viewMode === 'weekly' && (
              <div className={styles.navigationGroup}>
                <Tooltip title={t("previousWeek")}>
                  <Button
                    className={styles.navButton}
                    icon={<LeftOutlined />}
                    onClick={handlePrevWeek}
                  />
                </Tooltip>

                <div className={styles.currentWeekDisplay}>
                  <span className={styles.weekLabel}>{t("calenderWeek")} {selectedWeek}</span>
                  <span className={styles.dateRange}>{getWeekDateRange()}</span>
                </div>

                <Tooltip title={t("currentWeek")}>
                  <Button
                    className={styles.navButton}
                    icon={<HomeOutlined />}
                    onClick={handleCurrentWeek}
                  />
                </Tooltip>

                <Tooltip title={t("nextWeek")}>
                  <Button
                    className={styles.navButton}
                    icon={<RightOutlined />}
                    onClick={handleNextWeek}
                  />
                </Tooltip>
              </div>
            )}

            {/* Year Control - Shown in both modes */}
            <div className={styles.controlGroup}>
              <span className={styles.controlLabel}>{t("year")}:</span>
              <InputNumber
                min={2000}
                max={2100}
                value={selectedYear}
                onChange={(value) => setSelectedYear(value)}
                placeholder={t("year")}
                size="small"
                className={styles.viewerInput}
              />
            </div>

            {/* Month Control - Only shown in monthly mode */}
            {viewMode === 'monthly' && (
              <div className={styles.controlGroup}>
                <span className={styles.controlLabel}>{t("month")}:</span>
                <Select
                  value={selectedMonth}
                  onChange={setSelectedMonth}
                  size="small"
                  className={styles.viewerSelect}
                  style={{ minWidth: 120 }}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <Select.Option key={i + 1} value={i + 1}>
                      {dayjs().month(i).format('MMMM')}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            {/* Export Button */}
            <Button
              type="primary"
              onClick={() => exportToPDF(selectedWeek, selectedYear)}
              className={styles.exportButton}
            >
              {t("exportierenAlsPDF")}
            </Button>
          </div>
        </div>

        {/* Collapsible Legend */}
        <Collapse
          ghost
          className={styles.legendCollapse}
          defaultActiveKey={screens.md ? ['legend'] : []}
        >
          <Collapse.Panel
            header={<span className={styles.legendHeader}>{t("legende")}</span>}
            key="legend"
          >
            <div className={styles.legendTags}>
              {dayStatuses.map((status) => (
                <Tag
                  key={status}
                  className={styles.legendTag}
                  style={{
                    backgroundColor: getColorFromStatus(status),
                    color: getTextColorForStatus(status),
                    border: "none",
                    borderRadius: '6px',
                    fontWeight: '600',
                    textShadow: getTextColorForStatus(status) === '#ffffff' ? '0 1px 2px rgba(0,0,0,0.2)' : 'none'
                  }}
                >
                  {t(`statuses.${status?.toLowerCase()}`)}
                </Tag>
              ))}
            </div>
          </Collapse.Panel>
        </Collapse>

     
        {/* Enhanced Schedule Content */}
        <div ref={pdfRef} className={styles.scheduleContent}>
          {viewMode === "monthly" ? (
            <MonthlyScheduleTable
              dataSource={data}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              updateMonthPlan={updateMonthPlan}
            />
          ) : screens.md ? (
            <div className={styles.modernTable}>
              <Table
                dataSource={data}
                columns={columns}
                rowKey="name"
                pagination={false}
                scroll={{ x: "max-content" }}
                bordered={false}
                size="small"
                loading={loading}
                locale={{
                  emptyText: (
                    <div className={styles.emptyState}>
                      <div className={styles.emptyStateIcon}>📅</div>
                      <p>{t('noScheduleData')}</p>
                    </div>
                  )
                }}
              />
            </div>
          ) : (
            <List
              dataSource={data}
              loading={loading}
              locale={{
                emptyText: (
                  <div className={styles.emptyState}>
                    <div className={styles.emptyStateIcon}>📱</div>
                    <p>{t('noScheduleData')}</p>
                  </div>
                )
              }}
              renderItem={(employee) => (
                <List.Item style={{ padding: 0, border: 'none' }}>
                  <div className={styles.mobileUserBlock}>
                    <div className={styles.mobileUserHeader}>
                      <h3 className={styles.mobileUserName}>{employee.name}</h3>
                    </div>

                    <div className={styles.mobileScheduleGrid}>
                      {days.map((day) => {
                        const entry = employee.schedule[day] || {};
                        const { shifts = [], status } = entry;

                        return (
                          <div key={`${employee.name}-${day}`} className={styles.dayRow}>
                            <div className={styles.dayHeaderRow}>
                              <h4 className={styles.dayHeader}>
                                {t(`days.${day.toLowerCase()}`)}
                              </h4>
                              {status && status !== 'Work' && (
                                <Tag
                                  style={{
                                    backgroundColor: getColorFromStatus(status),
                                    color: getTextColorForStatus(status),
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontWeight: '600',
                                    fontSize: '11px',
                                    textShadow: getTextColorForStatus(status) === '#ffffff' ? '0 1px 2px rgba(0,0,0,0.2)' : 'none'
                                  }}
                                >
                                  {t(`statuses.${status?.toLowerCase()}`)}
                                </Tag>
                              )}
                            </div>

                            {shifts.length > 0 ? (
                              <div className={styles.shiftsDisplay}>
                                {shifts.map((shift, index) => (
                                  <Tag
                                    key={index}
                                    color={shiftColors[shift.type]}
                                    className={styles.shiftTag}
                                  >
                                    {shift.time}
                                  </Tag>
                                ))}
                              </div>
                            ) : (
                              status === 'Work' || !status ? (
                                <div className={styles.noShifts}>
                                  {t("noShifts")}
                                </div>
                              ) : null
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </List.Item>
              )}
            />
        )}
      </div>

      </div>


    );

           
          

    };





export default ScheduleViewer;
